import React from 'react';
import { CloseIcon } from '../../Icon';
import './AlertCloseButton.scss';
function AlertCloseButton(_a) {
    var onClick = _a.onClick, id = _a.id;
    return (React.createElement("button", { type: "button", className: "elmo-alert__button float-right", onClick: onClick, "data-testid": "elmo-alert-close-" + (id || 'default'), "aria-label": "Close" },
        React.createElement(CloseIcon, null)));
}
export default AlertCloseButton;
